module.exports = __webpack_public_path__ + "img/truck.4e5794d6.png";